"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("../../services/core");
var _reactstrap = require("reactstrap");
var _common = require("../../components/core/common");
var _icon = _interopRequireDefault(require("wever-core/dist/components/common/icon"));
var _address = _interopRequireDefault(require("./address"));
var _referents = _interopRequireDefault(require("./referents"));
var _end = _interopRequireDefault(require("../main/end"));
var _notifications = _interopRequireDefault(require("wever-core/dist/services/notifications"));
var _reactSelect = _interopRequireDefault(require("react-select"));
var _questionInput = require("./question-input");
var _util = require("./util");
var _utils = require("../../services/utils");
var _community = require("../../services/community");
var _security = _interopRequireDefault(require("wever-core/dist/services/security"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Ceci est un MVP.
 * Le code n'a pas pour but d'être beau mais fonctionnel.
 * Attention
 */
const ClubView = _ref => {
  let {
    community,
    communityKey,
    displayHeader,
    referencingId,
    childCommunityId
  } = _ref;
  const [diagnostic, setDiagnostic] = (0, _react.useState)();
  const [currentSlide, setCurrentSlide] = (0, _react.useState)(0);
  const [formDynamic, setFormDynamic] = (0, _react.useState)({
    capacity: 1
  });
  const [formerData, setFormerData] = (0, _react.useState)({});
  const [ended, setEnded] = (0, _react.useState)(false);
  const [loading, setLoading] = (0, _react.useState)(true);
  const [communityExist, setCommunityExist] = (0, _react.useState)(null);
  const [communityName, setCommunityName] = (0, _react.useState)();
  const isAuth = _security.default.isAuthenticated();
  // Pour la liste des différents référents
  const [referentsList, setReferentsList] = (0, _react.useState)({});
  const {
    locale
  } = (0, _react.useContext)(_core.ContextCore);
  const loadDiagnostic = async () => {
    try {
      const httpResponse = await _core._Api.get(`/communities/referencement-club-diagnostic?key=${communityKey}`);
      const diagnostic = httpResponse.data;
      // ON va trier les éléments du diagnostic (blocs.order, bloc.questions.order)

      diagnostic.blocs.forEach(bloc => {
        bloc.questions.sort((a, b) => a.order - b.order);
      });
      diagnostic.blocs.sort((a, b) => a.order - b.order);
      setDiagnostic(diagnostic);
      // CHARGEMENT DES DONNEES

      if (referencingId) {
        const httpStructureResponse = await _core._Api.get(`/structure_referencements/${referencingId}`);
        const formerDataResponse = httpStructureResponse.data;
        formerDataResponse.activity = formerDataResponse.activity?.['@id'];
        formerDataResponse.structure = formerDataResponse.structure?.['@id'];
        console.log('test', formerDataResponse);
        const clubValues = formerDataResponse.club.values;
        const sitesAddress = formerDataResponse['sites']['address'];
        let capacity = 0;
        if (formerDataResponse['sites'] && formerDataResponse['sites'].length > 0) {
          for (let site of formerDataResponse['sites']) {
            capacity += parseInt(site['capacity']);
          }
        }
        clubValues['siret'] = formerDataResponse['siret'];
        clubValues['address'] = clubValues['address'] || sitesAddress;
        clubValues['capacity'] = capacity > 1 ? capacity : clubValues['capacity'];
        if (!clubValues['referents'] || clubValues['referents'].length === 0) {
          clubValues['referents'] = [formerDataResponse['referent']];
        }
        console.log(clubValues);
        setFormerData(formerDataResponse);
        setFormDynamic(httpStructureResponse.data.club.values);
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };
  const getQuestionInput = question => {
    return (0, _questionInput.getInput)(question, formDynamic, setFormDynamicElement, locale, _core._translate);
  };
  const updateSlide = indice => {
    const bloc = diagnostic.blocs[currentSlide + indice - 2];
    if (bloc && bloc.displayConditions && bloc.displayConditions.length > 0) {
      const conditions = bloc.displayConditions;

      // on récupère les conditions et on vérifie s'il ya l'information dans les réponses données
      const isValid = (0, _util.checkCondition)(conditions[0], formDynamic);
      if (!isValid) {
        updateSlide(indice + (indice > 0 ? 1 : -1));
        return;
      }
    }
    setCurrentSlide(currentSlide + indice);
  };
  const sendSlides = async () => {
    if (!(0, _utils.isEmailValid)(formDynamic.referents[0]?.email, _core._translate) || formDynamic.referents[0]?.phon && !(0, _utils.isPhoneValid)(formDynamic.referents[0]?.phone, _core._translate) || !(0, _utils.isSirenValid)(formDynamic.siret, _core._translate)) {
      return;
    }
    try {
      let structureId = parseInt(referencingId);
      console.debug('Send slides former :', formerData);
      let sites = formerData?.sites;
      if (!sites || sites.length === 0) {
        sites = [{
          capacity: parseInt(formDynamic['capacity']),
          address: formDynamic['address'],
          name: formDynamic['name']
        }];
      }
      const structureReferencement = {
        community: '/communities/' + community['id'],
        id: structureId,
        name: formDynamic['name'],
        siret: formDynamic['siret'],
        referents: formDynamic['referents'],
        sites: sites,
        ...formerData,
        club: {
          diagnostic: diagnostic.id,
          values: formDynamic
        },
        state: childCommunityId ? 'accepted' : 'waiting'
      };
      if (childCommunityId) {
        structureReferencement['childCommunity'] = '/communities/' + childCommunityId;
      }
      if (structureId && structureId > 0) {
        await _core._Api.put('/structure_referencements/' + structureId, structureReferencement);
      } else {
        await _core._Api.post('/structure_referencements', structureReferencement);
      }
      _core._Notifications.success((0, _core._translate)('registerapp_success'), (0, _core._translate)('registerapp_send_success'));
      setEnded(true);
    } catch (e) {
      console.error(e);
      _core._Notifications.error((0, _core._translate)('registerapp_error'), (0, _core._translate)('registerapp_send_failed'));
    }
  };
  const setFormDynamicElement = (key, value) => {
    setFormDynamic({
      ...formDynamic,
      [key]: value
    });
  };
  const footerBtn = function () {
    let displayPrevious = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    let displayNext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    let displayEnd = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    let validator = arguments.length > 3 ? arguments[3] : undefined;
    return (0, _questionInput.getSlideFooter)(validator, _core._translate, updateSlide, sendSlides, displayPrevious, displayNext, displayEnd);
  };
  const validateSlide1 = () => {
    return (0, _util.isSlide1Valid)(formDynamic, _core._translate, _notifications.default);
  };
  const isContactFilled = contact => {
    return contact['firstname'] || contact['lastname'] || contact['email'] || contact['phone'];
  };
  const isContactValid = contact => {
    const isValid = contact['firstname'] && contact['lastname'] && contact['email'] && contact['phone'] && contact['job'] && contact['gender'];
    return isValid;
  };
  const validateContact = alias => {
    if (!formDynamic[alias] || !isContactValid(formDynamic[alias][0])) {
      _notifications.default.error((0, _core._translate)('collectorapp_server_error'), (0, _core._translate)('registerapp_club_error_contact_need_one_entire'));
      return false;
    }
    const form = formDynamic[alias].filter(contact => isContactFilled(contact));
    let isValid = true;
    form.forEach((contact, index) => {
      if (!isContactValid(contact)) {
        isValid = false;
      }
    });
    if (!isValid) {
      _notifications.default.error((0, _core._translate)('collectorapp_server_error'), (0, _core._translate)('registerapp_club_error_contact_fill_all_when_starting_to_write'));
    }
    return isValid;
  };
  const loadColors = () => {
    const weverColor = community.colors?.primaryColor || 'red';
    const elements = document.querySelectorAll('.text-color-1');
    const btnElements = document.querySelectorAll('.btn-wever-red');
    const weverBorderColors = document.querySelectorAll('.wever-border-color');

    // Changer la couleur du texte pour chaque élément
    elements.forEach(element => {
      element.style.color = weverColor;
    });
    btnElements.forEach(element => {
      element.style.backgroundColor = weverColor;
    });
    if (weverBorderColors.length > 0) {
      for (const weverBorderColor of weverBorderColors) {
        weverBorderColor.style.borderColor = weverColor;
      }
    }
    const formLabels = document.querySelectorAll('.form-label');
    formLabels.forEach(element => {
      const text = element.innerHTML;
      // Remplacer les premiers ** par <b>
      const boldText = text.replace('**', '<span class="fw-bold text-gray-1">');

      // Remplacer les derniers ** par </b>
      let finalText = boldText.replace('**', '</span>');
      finalText = finalText.replaceAll('__BREAK__', '<br />');

      // Mettre à jour le contenu HTML avec le texte modifié
      element.innerHTML = finalText;
    });
  };
  const isCommunityAlreadyExist = async event => {
    const name = event.target?.value;
    setCommunityName(name);
    const exist = await (0, _community.isCommunityOnline)(name);
    setCommunityExist(exist);
  };
  (0, _react.useEffect)(() => {
    if (!communityKey) {
      return;
    }
    loadDiagnostic();
  }, [_security.default.isAuthenticated()]);
  (0, _react.useEffect)(() => {
    if (!diagnostic || loading) {
      return;
    }
    loadColors();
  }, [diagnostic, loading]);
  if (!diagnostic || !community || !community.logo || loading) {
    return /*#__PURE__*/_react.default.createElement("div", null, "Loading...");
  }
  if (ended) {
    return /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
      className: "h-100"
    }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
      className: "col-12 pt-3 d-flex flex-column align-items-center",
      style: {
        maxHeight: '100vh'
      }
    }, /*#__PURE__*/_react.default.createElement(_end.default, {
      media: community.logo
    })));
  }
  return /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "h-100 w-100 p-0 m-0",
    id: "container-club"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    sm: 12,
    className: `p-0 m-0 container-header bg-light-1 py-2 header wever-border-color ${displayHeader ? 'd-block' : 'd-none'}`
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "p-0 m-0 "
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    xs: "5",
    sm: "3",
    md: "2",
    lg: "2",
    xl: "1"
  }, /*#__PURE__*/_react.default.createElement(_common._Media, {
    data: community.logo,
    className: "img-logo-register-club"
  })), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    className: "d-flex align-items-center ",
    id: "title-register-club"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "fw-bold m-0"
  }, community.referencementClubTitle || (0, _core._translate)('registerapp_club_title'))))), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    sm: "12",
    id: "container-question",
    className: "d-flex flex-column align-items-center justify-content-center mt-3 py-5"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "w-100 d-flex flex-column align-items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "bg-light-1 p-3 mb-3 col-sm-11 col-md-10 card",
    style: {
      display: currentSlide !== 0 ? 'none' : null
    }
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "fw-bold mb-5"
  }, (0, _core._translate)('registerapp_club_general')), /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "my-4 question"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    md: 6,
    lg: 5
  }, (0, _core._translate)('registerapp_club_company_organisation'), " ", /*#__PURE__*/_react.default.createElement("span", {
    className: "text-color-1"
  }, "*")), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Input, {
    type: "text",
    value: formDynamic['name'] ?? null,
    onChange: e => setFormDynamicElement('name', e.target.value),
    onBlur: e => isCommunityAlreadyExist(e)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "p-2"
  }, communityExist === true && communityName && communityName !== '' ? /*#__PURE__*/_react.default.createElement("p", {
    className: "text-danger m-0"
  }, (0, _core._translate)('registerapp_club_company_organisation_exist')) : null))), /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "mt-4 mb-4 question"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    md: 6,
    lg: 5
  }, (0, _core._translate)('common_siret')), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactstrap.Input, {
    type: "text",
    pattern: "^\\d{14}$",
    placeholder: "Num\xE9ro \xE0 14 chiffres",
    value: formDynamic['siret'] ?? null,
    onBlur: e => {
      if (e.target.value && e.target.value.length !== 14) {
        _notifications.default.error((0, _core._translate)('collectorapp_server_error'), (0, _core._translate)('registerapp_club_error_siret_invalid'));
        return;
      }
    },
    onChange: e => {
      if (e.target.value && e.target.value.length > 14) {
        return;
      }
      setFormDynamicElement('siret', e.target.value);
    }
  }))), /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "mb-4 question"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    md: 6,
    lg: 5
  }, (0, _core._translate)('registerapp_club_code_naf_ape')), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactstrap.Input, {
    type: "text",
    pattern: "^\\d{4}[A-Z]$",
    placeholder: "ex: 4708Z",
    value: formDynamic['code_naf_ape'] ?? null,
    onChange: e => {
      if (e.target.value.length > 5) {
        return;
      }
      setFormDynamicElement('code_naf_ape', e.target.value);
    }
  }))), /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "my-4 question"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    md: 6,
    lg: 5
  }, (0, _core._translate)('registerapp_club_created_at'), " ", /*#__PURE__*/_react.default.createElement("span", {
    className: "text-color-1"
  }, "*")), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactstrap.Input, {
    type: "date",
    value: formDynamic['createdAt'],
    onChange: e => setFormDynamicElement('createdAt', e.target.value),
    max: (0, _util.todayString)()
  }))), /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "my-4 question"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    md: 6,
    lg: 5
  }, (0, _core._translate)('registerapp_club_turnover'), " (\u20AC) ", /*#__PURE__*/_react.default.createElement("span", {
    className: "text-color-1"
  }, "*")), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactSelect.default, {
    placeholder: "S\xE9lectionner",
    value: (0, _util.turnoverSelect)(_core._translate).filter(opt => opt.value === formDynamic['turnover'])[0] ?? null,
    options: (0, _util.turnoverSelect)(_core._translate),
    onChange: e => setFormDynamicElement('turnover', e.value)
  }))), /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "my-4 question"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    md: 6,
    lg: 5
  }, (0, _core._translate)('registerapp_club_address'), " ", /*#__PURE__*/_react.default.createElement("span", {
    className: "text-color-1"
  }, "*")), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, null, /*#__PURE__*/_react.default.createElement(_address.default, {
    value: formDynamic['address'],
    onChange: opt => setFormDynamicElement('address', opt)
  }))), /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "my-4 question"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    md: 6,
    lg: 5
  }, (0, _core._translate)('structurereferencementapp_site_capacity'), " ", /*#__PURE__*/_react.default.createElement("span", {
    className: "text-color-1"
  }, "*")), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactstrap.Input, {
    type: "number",
    onChange: e => {
      const capacity = parseInt(e.target.value);
      if (capacity < 1) {
        _notifications.default.error((0, _core._translate)('collectorapp_server_error'), (0, _core._translate)('registerapp_club_error_capacity_more_than_1'));
        return;
      }
      setFormDynamicElement('capacity', capacity);
    },
    min: 0,
    value: formDynamic['capacity']
  }))), footerBtn(false, isAuth || !isAuth && false === communityExist, false, validateSlide1)), /*#__PURE__*/_react.default.createElement("div", {
    className: "bg-light-1 p-3 mb-3 col-sm-11 col-md-10 card",
    style: {
      display: currentSlide !== 1 ? 'none' : null
    }
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "fw-bold mb-5"
  }, (0, _core._translate)('registerapp_club_general_referent')), /*#__PURE__*/_react.default.createElement("p", {
    className: "form-label"
  }, (0, _core._translate)('registerapp_club_general_referent_description')), /*#__PURE__*/_react.default.createElement(_referents.default, {
    alias: "referents",
    value: formDynamic['referents'] ?? [],
    onChange: referents => setFormDynamicElement('referents', referents),
    min: "4",
    jobs: ["Dirigeant", "Contact comptabilité", "Responsable RH", "Responsable RSE"]
  }), footerBtn(true, true, false, () => validateContact('referents'))), diagnostic && diagnostic.blocs.map((bloc, index) => /*#__PURE__*/_react.default.createElement("div", {
    key: `bloc_${index}`,
    className: "bg-light-1 card p-3 mb-3 col-sm-11 col-md-10",
    style: {
      display: currentSlide !== index + 2 ? 'none' : null
    }
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "fw-bold mb-5"
  }, bloc.name[locale]), bloc.questions.map(question => {
    if (question.displayConditions && question.displayConditions.length > 0) {
      if (!(0, _util.checkCondition)(question.displayConditions[0], formDynamic)) {
        return null;
      }
    }
    const questionColIsDisplayable = question.type.name !== "image" && question.name[locale] && question.name[locale] !== " ";
    const displayOnAll = (question.type.name === "checkbox" || question.type.name === "radio") && question.name[locale] !== " ";
    return /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
      className: "my-4 question",
      key: `block_${index}_question_${question.alias}`
    }, questionColIsDisplayable ? /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
      className: `col ${!displayOnAll ? 'col-xs-12 col-sm-6 col-lg-5' : ''}`
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: 'm-0 p-0 ' + `${question.description && question.description[locale] ? 'has-description' : ''}`,
      id: question.alias
    }, question.name[locale], question.required ? /*#__PURE__*/_react.default.createElement("span", {
      className: "text-color-1 mx-2"
    }, "*") : null, question.description && question.description[locale] ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_icon.default, {
      name: "question-circle",
      className: "question-mark mx-1 text-color-1"
    }), /*#__PURE__*/_react.default.createElement(_reactstrap.UncontrolledPopover, {
      placement: "bottom",
      target: question.alias,
      trigger: "hover",
      className: "question-popover"
    }, /*#__PURE__*/_react.default.createElement(_reactstrap.PopoverBody, null, /*#__PURE__*/_react.default.createElement("iframe", {
      srcDoc: `<div style="font-family: sans-serif, 'Roboto';">${question.description[locale]}</div>`,
      width: "100%",
      height: "100%",
      style: {
        border: 'none',
        boxShadow: 'none'
      },
      title: `description_${question.alias}`
    })))) : null)) : null, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
      className: `d-flex justify-content-center col ${!displayOnAll ? 'col-sm-12' + (questionColIsDisplayable && 'col-md-6 col-lg-7') : ''}`
    }, getQuestionInput(question)));
  }), footerBtn(true, diagnostic.blocs.length !== index + 1, diagnostic.blocs.length === index + 1, () => {
    let isValid = true;
    const errors = [];
    bloc.questions.forEach(question => {
      if (question.required && !formDynamic[question.alias]) {
        isValid = false;
        errors.push(question.alias);
      }
    });
    if (!isValid) {
      _notifications.default.error((0, _core._translate)('collectorapp_server_error'), (0, _core._translate)('registerapp_club_error_questions'));
      console.error(errors);
    }
    return isValid;
  }))), currentSlide >= diagnostic.blocs.length + 2 ? /*#__PURE__*/_react.default.createElement("div", {
    className: "bg-light-1 p-3 mb-3 w-75",
    style: {
      borderRadius: '5px'
    }
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "fw-bold mb-5"
  }, (0, _core._translate)('registerapp_club_end_title')), footerBtn(true, false, true, () => {
    let isValid = true;
    const errors = [];
    const bloc = diagnostic.blocs[diagnostic.blocs.length - 1];
    console.log('END', diagnostic, bloc);
    bloc.questions.forEach(question => {
      if (question.required && !formDynamic[question.alias]) {
        isValid = false;
        errors.push(question.alias);
      }
    });
    if (!isValid) {
      _notifications.default.error((0, _core._translate)('collectorapp_server_error'), (0, _core._translate)('registerapp_club_error_questions'));
      console.error(errors);
    }
    return false;
  })) : null)));
};
var _default = exports.default = ClubView;